import { WallData } from '../data/wall/Wall';

export enum EOperationType {
  WallAdd = 1,
  WallDel = 2,
  WallModify = 3,
  SeparateWallAdd = 4,
  SeparateWallDel = 5,
  SeparateWallModify = 6,
  RoomAdd = 7,
  RoomDel = 8,
  RoomModify = 9,
  RegionAdd = 10,
  RegionDel = 11,
  RegionModify = 12,
  FaceModify = 13,
  ClearAll = 14,
  ClearMaterials = 15,
  ColumnAdd = 16,
  ColumnDel = 17,
  ColumnModify = 18,
  WindowDoorAdd = 19,
  WindowDoorDel = 20,
  WindowDoorModify = 21,
  FurnitureAdd = 22,
  FurnitureDel = 23,
  FurnitureModify = 24,
  FurnitureDelAll = 26,
  SetLayerHeight = 27,
  SetFloorPlanConfig = 28,
  ApplyAutoLayoutResult = 29,
  ClearArea = 30,
  ModelGroupModify = 31,
  AssemblyModify = 32,
  AssemblyAdd = 33,
  MultipleEntityModify = 34,
  MultipleEntityAdd = 35,
  Align = 36,
  AreaDimensionAdd = 37,
  AreaDimensionDel = 38,
  LinearDimensionAdd = 39,
  LinearDimensionDel = 40,
  LinearDimensionModify = 41,
  CadRecognitionImport = 42
}

export enum EWallModifyType {
  Update = 'update',
  Add = 'add',
  Del = 'del'
}
export interface IWallModifyUpdateItem {
  wallId: string;
  type: EWallModifyType.Update;
  newWallData: Partial<WallData>;
}
export interface IWallModifyAddItem {
  wallId: string;
  type: EWallModifyType.Add;
  newWallData: WallData;
}
export interface IWallModifyDelItem {
  wallId: string;
  type: EWallModifyType.Del;
  newWallData: undefined;
}
